<template>
  <b-container class="home-container container-xl">
    <b-row col="12" class="mb-4 text-left">
      <b-col sm="12" md="12" lg="9" xl="9">
        <h1>MGFÜ Tanácsadási Voucher Program</h1>
        <p class="my-4" style="font-size: 16px">
          A program támogatást nyújt a fejlődésre, növekedésre, változásra nyitott vállalkozások számára, annak
          érdekében, hogy alkalmazkodni tudjanak a piaci viszonyok által támasztott fokozódó technológiai, szervezeti és
          emberi erőforrásokat érintő kihívásokhoz. A Voucher Program célja, hogy támogassa a Budapesten és Pest
          vármegyében működő mikro-, kis- és középvállalkozásokat tanácsadási szolgáltatások igénybevételében, előre
          meghatározott témakörökben, amelyhez az állam az MGFÜ közreműködésével vissza nem térítendő támogatást
          biztosít. <br />
          A támogatási kérelmet 2023. április 27. 12:00 órától 2023. június 1. 12:00 óráig lehet benyújtani.
        </p>

        <div class="my-5">
          <p>
            Felhívjuk az MGFÜ Tanácsadási Voucher Program keretében támogatást igénylők figyelmét, hogy a program
            eredeti 300 millió forint keretösszege 400 millió forint összegre módosult. Továbbá pontosításra került a
            Támogatói Okirat kibocsátásának folyamata is, amely Működési Kézikönyv 1.1. alfejezetében található.
            <br />

            A módosítással érintett dokumentumok a „Letölthető dokumentumok” menüpontban érhetőek el.
          </p>
        </div>
        <p class="mb-5">
          Tájékoztatjuk, hogy az MGFÜ Tanácsadói Voucher Program keretében megjelent a záró kifizetési igénylés és a
          kapcsolódó beszámoló benyújtásával kapcsolatos információkat részletező Elszámolási Útmutató. A dokumentum a
          „Letölthető dokumentumok” menüpontban érhető el.
        </p>
        <p class="mb-5">
          Az Elszámolási Útmutató kibővítésre került az elektronikus számlák záradékolásával kapcsolatos elvárásokkal.
        </p>
        <p class="mb-5">
          Tájékoztatjuk, hogy a nagyszámú érdeklődésre, valamint az ügyfélszolgálati megkeresésekre tekintettel az MGFÜ
          Tanácsadási Voucher Program projekt záró kifizetési igénylésének és a kapcsolódó beszámoló benyújtásának
          határideje 2023. október 16. napjáról 2023. október 20. napjára változott. Tájékoztatjuk továbbá, hogy a záró
          kifizetési igénylés és a kapcsolódó beszámoló benyújtásához tartozó online felület hamarosan elérhetővé válik.
          A pályázati felület megnyitásáról minden Kedvezményezettet értesíteni fogunk a pályázati felületen megadott
          kapcsolattartói e-mail címen keresztül.
        </p>
        <p class="mb-5">
          <strong>
            Az MGFÜ Tanácsadási Voucher Program kapcsán tájékoztatjuk a program kedvezményezettjeit, hogy a projekt záró
            kifizetési igénylésének és a kapcsolódó beszámoló benyújtásának lehetősége megnyitásra került a pályázói
            felületen, továbbá felhívjuk a figyelmüket, hogy a nevezett dokumentumok benyújtási határideje 2023. október
            16. napjáról 2023. október 20. napjára változott!
          </strong>
        </p>
        <b-row>
          <b-col lg="5">
            <b-button
              href="https://vali.hu/static/MGFU_felhivas_voucher_3_mod.pdf"
              target="_blank"
              class="d-flex align-items-center justify-content-center my-1 my-lg-0"
            >
              Tovább a pályázati felhíváshoz
            </b-button>
          </b-col>
          <b-col lg="5">
            <b-button
              href="https://voucher.ifka.hu/kau-login"
              target="_blank"
              class="d-flex align-items-center justify-content-center  my-1 my-lg-0"
            >
              Tovább a pályázat kitöltő felületre
            </b-button>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <b-row class="text-left my-5">
      <b-col lg="9">
        <h2>Támogatás igénybevételéhez szükséges nyilatkozatok és dokumentumok</h2>
      </b-col>
    </b-row>
    <b-row id="doc_downloads" cols="12" class="text-left mb-4">
      <b-col lg="6">
        <p class="mb-4"><strong>Letölthető dokumentumok</strong></p>
        <div class="download">
          <ul>
            <li>
              <a
                class="services-button-wrapper"
                download
                target="_blank"
                href="https://vali.hu/static/MGFU_felhivas_voucher_4.pdf"
              >
                Címzetti felhívás - MGFÜ Tanácsadási Voucher Program
                <img src="../assets/img/icons/download.svg" />
              </a>
            </li>
            <li>
              <a
                class="services-button-wrapper"
                download
                target="_blank"
                href="https://vali.hu/static/MGFU_felhivas_voucher_3_mod.pdf"
              >
                Címzetti felhívás - MGFÜ Tanácsadási Voucher Program (archív)
                <img src="../assets/img/icons/download.svg" />
              </a>
            </li>
            <li>
              <a
                class="services-button-wrapper"
                download
                target="_blank"
                href="https://vali.hu/static/MGFU_felhivas_voucher_2_mod.pdf"
              >
                Címzetti felhívás - MGFÜ Tanácsadási Voucher Program (archív)
                <img src="../assets/img/icons/download.svg" />
              </a>
            </li>
            <li>
              <a
                class="services-button-wrapper"
                download
                target="_blank"
                href="https://vali.hu/static/Szandeknyilatkozat_sablon.docx"
              >
                Szándéknyilatkozat sablon
                <img src="../assets/img/icons/download.svg" />
              </a>
            </li>
            <li class="d-none">
              <a
                class="services-button-wrapper"
                download
                target="_blank"
                href="https://vali.hu/static/Tamogatoi_okirat_tervezet.pdf"
              >
                Támogatói okirat tervezet
                <img src="../assets/img/icons/download.svg" />
              </a>
            </li>
            <li>
              <a
                class="services-button-wrapper"
                download
                target="_blank"
                href="https://vali.hu/static/MGFU_tanacsadasi_voucher_program_elszamolasi_utmutato_2023_oktober.pdf"
              >
                Elszámolási Útmutató
                <img src="../assets/img/icons/download.svg" />
              </a>
            </li>
            <li>
              <a
                class="services-button-wrapper"
                download
                target="_blank"
                href="https://vali.hu/static/MGFU_tanacsadasi_voucher_program_elszamolasi_utmutato.pdf"
              >
                Elszámolási Útmutató (archív)
                <img src="../assets/img/icons/download.svg" />
              </a>
            </li>
          </ul>
        </div>
      </b-col>
      <b-col lg="6">
        <p class="mb-4"><strong>Letölthető dokumentumok</strong></p>
        <div class="download">
          <ul>
            <li class="d-none">
              <a
                class="services-button-wrapper"
                download
                target="_blank"
                href="https://vali.hu/static/Tovabbadott_tamogatosi_utmutato.pdf"
              >
                Továbbadott támogatási útmutató
                <img src="../assets/img/icons/download.svg" />
              </a>
            </li>
            <li>
              <a
                class="services-button-wrapper"
                download
                target="_blank"
                href="https://vali.hu/static/Mukodesi_kezikonyv_1_mod.pdf"
              >
                Működési kézikönyv
                <img src="../assets/img/icons/download.svg" />
              </a>
            </li>
            <li>
              <a
                class="services-button-wrapper"
                download
                target="_blank"
                href="https://vali.hu/static/Mukodesi_kezikonyv.pdf"
              >
                Működési kézikönyv (archív)
                <img src="../assets/img/icons/download.svg" />
              </a>
            </li>
            <li id="egyeni_vallalkozo_nyilatkozata">
              <a
                class="services-button-wrapper"
                download
                target="_blank"
                href="https://vali.hu/static/Egyeni_vallalkozo_nyilatkozata_sablon.docx"
              >
                Egyéni Vállalkozó nyilatkozata sablon
                <img src="../assets/img/icons/download.svg" />
              </a>
            </li>
            <li>
              <a
                class="services-button-wrapper"
                download
                target="_blank"
                href="https://vali.hu/static/Adatkezelesi_tajekoztato_1_mod.pdf"
              >
                Adatkezelési tájékoztató
                <img src="../assets/img/icons/download.svg" />
              </a>
            </li>
            <li>
              <a
                class="services-button-wrapper"
                download
                target="_blank"
                href="https://vali.hu/static/Adatkezelesi_tajekoztato.pdf"
              >
                Adatkezelési tájékoztató (archív)
                <img src="../assets/img/icons/download.svg" />
              </a>
            </li>
            <li>
              <a
                class="services-button-wrapper"
                download
                target="_blank"
                href="https://vali.hu/static/MGFU_Tanacsadasi_Voucher_Program-tamogatott_vallalkozasok.pdf"
              >
                Támogatott vállalkozások listája
                <img src="../assets/img/icons/download.svg" />
              </a>
            </li>
          </ul>
        </div>
      </b-col>
    </b-row>

    <b-row class="text-left mb-4">
      <b-col>
        <h2 class="mb-4">Támogatás igénybevételének folyamata</h2>
        <img class="containers-svg" src="../assets/img/voucher-folyamatabra-0622.jpg" />
      </b-col>
    </b-row>
    <!-- <b-col lg="5">
      <b-button
        href="https://vali.hu/www/static/Voucher-Program_Palyazati_Felhivas"
        target="_blank"
        class="d-flex align-items-center justify-content-center"
      >
        Tovább a pályázati felhíváshoz
      </b-button>
    </b-col> -->
  </b-container>
</template>

<script>
export default {}
</script>

<style scoped>
ul {
  list-style-image: url('../assets/img/icons/tick_mark.svg');
}

.download ul {
  list-style-type: none;
  list-style-image: none;
  padding: 0;
}

.download li {
  font-weight: 700;
  background: #f2f8fa;
}

li {
  padding-left: 20px;
  margin-bottom: 10px;
}

.services-button-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 24px;
  padding-top: 24px;
  padding-right: 24px;
}

.containers-svg {
  width: 100%;
  height: auto;
}

@media (max-width: 575px) {
  h1 {
    font-size: 24px;
    font-weight: 400;
  }

  h2 {
    font-size: 18px;
    font-weight: 700;
  }
}
</style>
